/**
 * group聊天窗口
 * Bai.Zhiming
 * 2019-7-19
 */
angular.module("dialogBoxGroupModule", []).
directive("dialogBoxGroup", ['$q', 'convertMsgtoHtml', 'dialogBoxService', '$timeout', 'imService', '$filter', function($q, convertMsgtoHtml, dialogBoxService, $timeout, imService, $filter) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            sessionInfo: '=',
            loginInfo: '=',
            fn: '=' //滚动方法集合
        },
        templateUrl: "./IM/chatWindow/dialogBox/dialogBoxGroup/dialogBoxGroup_tpl.html",
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [showAndFormatTime description] 显示以及格式化时间
             * @param  {[type]} item  [description] 聊天信息
             * @param  {[type]} index [description] 下标
             * @return {[type]}       [description]
             */
            scope.showAndFormatTime = function(item, index) {
                let compareFormatTime = imService.dateFormat3(item.time);
                item.formatTime = imService.dateFormat2(item.time);
                let preIndex = index - 1;
                if (preIndex == -1) {
                    return true;
                }
                let preInfoTime = imService.dateFormat3(scope.data.groupHistoryMsgs[preIndex].time); //下一条信息的时间
                if (compareFormatTime == preInfoTime) {
                    return false; //如果本条信息的时间和上一条信息时间相同，则不显示本条信息了
                } else {
                    return true; //若果本条信息的时间和上一条时间信息相同，则显示本条信息
                }
            }
            /**
             * [scrollTopLoadMore description] 滚动到顶部加载更多
             * @return {[type]} [description]
             */
            scope.scrollTopLoadMore = function() {
                let height = $element.find(".message_area ul").height();
                scope.loaders = imService.getGroupInfo(scope.sessionInfo.ToAccount).then(resp => {
                    scope.loaders = imService.getGroupHistory(scope.sessionInfo.ToAccount, 15, resp[0].NextMsgSeq - 1 - scope.data.groupHistoryMsgs.length);
                    return scope.loaders;
                }).then(resp => {
                    setAutoRead();
                    let newMsg = resp;
                    composeNewMessage(newMsg);
                    imagesLoadFinish().then(() => {
                        let height_ = $element.find(".message_area ul").height();
                        let different = height_ - height;
                        different = different == 0 ? 10 : different;
                        $element.find(".message_area")[0].scrollTop = different;
                    });
                });
            }
            /**
             * [imagesLoadFinish description] 图片全部加载完成
             * @return {[type]} [description]
             */
            function imagesLoadFinish() {
                let deffer = $q.defer();
                $timeout(() => {
                    let $imgsAll = $element.find(".message_area img");
                    let imgs = [];
                    let promises = [];
                    $imgsAll.each(function(index) {
                        if ($(this).attr("loaded") != undefined || $(this).hasClass("avatar") || this.complete) return;
                        imgs.push(this);
                    });
                    imgs.forEach(item => {
                        promises.push(loadImg(item));
                    });
                    if (promises.length == 0) {
                        deffer.resolve();
                    } else {
                        $q.all(promises).then(() => {
                            deffer.resolve();
                        });
                    }
                }, 800);
                /**
                 * [loadImg description] 加载图片
                 * @param  {[type]} img [description] 图片节点
                 * @return {[type]}     [description]
                 */
                function loadImg(img) {
                    let deffer_ = $q.defer();
                    img.onload = function() {
                        $(img).attr("onload", true);
                        deffer_.resolve();
                    };
                    img.onerror = function() {
                        $(img).attr("onload", false);
                        deffer_.resolve();
                    }
                    return deffer_.promise;
                }
                return deffer.promise;
            }
            /**
             * [listenNewMessage description] 监听新消息进入
             * @return {[type]} [description]
             */
            function listenNewMessage() {
                scope.$on("newMessage", (event, data) => {
                    data.forEach(item => {
                        let sess = item.sess;
                        if (sess.type() == 'C2C') return;
                        if (sess.id() != scope.sessionInfo.ToAccount) return;
                        composeNewMessage(data)
                        scrollToBottom();
                    });
                });
            }
            /**
             * [composeNewMessage description] 组装新的历史记录
             * @param  {[type]} newMsg [description] 新历史记录数据
             * @return {[type]}        [description]
             */
            function composeNewMessage(newMsg) {
                newMsg.forEach(item => {
                    let flag = scope.data.groupHistoryMsgs.every(item_ => {
                        return item.random != item_.random;
                    });
                    if (flag) {
                        scope.data.groupHistoryMsgs.push(item);
                    }
                });
                scope.data.groupHistoryMsgs.sort((x, y) => {
                    return x.time - y.time;
                });
            }
            /**
             * [sendMsg description] 发送消息
             * @return {[type]} [description]
             */
            scope.sendMsg = function() {
                let content = scope.status.ce.getContent();
                imService.sendMsg(
                    content,
                    'GROUP',
                    0,
                    scope.sessionInfo.ToAccount,
                    scope.loginInfo.USERHEAD,
                    scope.loginInfo.TENANTID + "_" + scope.loginInfo.USERNAME,
                    scope.loginInfo.TRUENAME,
                    (resp, msg) => {
                        sendMessageSuccess(msg);
                    }
                );
            };
            /**
             * [sendMessageSuccess description] 发送消息成功回调
             * @return {[type]} [description]
             */
            function sendMessageSuccess(msg) {
                scope.data.groupHistoryMsgs.push(msg);
                scrollToBottom(true);
                scope.status.ce.clear();
                scope.$root.$broadcast('newMessageToLeft', [msg]);
                /*imService.getGroupInfo(scope.sessionInfo.ToAccount).then(resp => {
                    return imService.getGroupHistory(scope.sessionInfo.ToAccount, angular.isArray(resp_) ? resp_.length : 1, resp[0].NextMsgSeq - 1);
                }).then(resp => {
                    scope.data.groupHistoryMsgs = scope.data.groupHistoryMsgs.concat(resp);
                    scrollToBottom();
                    scope.status.ce.clear();
                    scope.$root.$broadcast('newMessage', resp);
                });*/
            }
            /**
             * [scrollToBottom description] 初始化时，滚动到底部，看到最新消息
             * @param  {[boolean]} isSelf [description] 是否是自己
             * @return {[type]} [description]
             */
            function scrollToBottom(isSelf) {
                imagesLoadFinish().then(() => {
                    let $message_area = $element.find(".message_area");
                    let $ul = $message_area.find("ul").eq(0);
                    let scrollTop = $ul.height() + 50 - $message_area.height();
                    $element.find(".message_area").stop(true, true).animate({
                            scrollTop: scrollTop
                        },
                        isSelf ? 0 : 200,
                        'linear',
                        () => {

                        });
                });
            }
            /**
             * [content description] 聊天正文
             * @param  {[type]} item [description] 聊天信息
             * @return {[type]}      [description]
             */
            scope.content = function(item) {
                //return item.getElems()[0].content.text.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;');
                return convertMsgtoHtml.MsgToHtml(item);
            };
            /**
             * [setAutoRead description] 上报已读
             * @param {[boolean]} isResetAll    [description] 是否重置之前的未读消息
             */
            function setAutoRead() {
                let type = 'GROUP';
                let account = scope.sessionInfo.ToAccount;
                let selSess = webim.MsgStore.sessByTypeId(type, account);
                webim.setAutoRead(selSess, true, true);
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    ce: "", //简易聊天编辑器实例
                };
                scope.data = {
                    groupHistoryMsgs: []
                };
                scope.fn.scrollBottom = scrollToBottom;
                scope.fn.showCallback = setAutoRead;
                scope.uploadImagesFn = { //图片上传回调集合
                    getImages(images) {
                        let htmlContent = "";
                        images.forEach(resp => {
                            let img = document.createElement("img");
                            img.src = (() => {
                                return resp.URL_INFO.map(item => {
                                    return item.DownUrl
                                }).join("#");
                            })();
                            htmlContent += img.outerHTML;
                        });
                        scope.status.ce.editorFocus();
                        scope.status.ce.insertHtml(htmlContent);
                        /*scope.loaders = dialogBoxService.sendImages(images, 'GROUP', scope.sessionInfo.ToAccount, scope.sessionInfo.GroupImage ? scope.sessionInfo.GroupImage : './images/group_chart_default.png', scope.loginInfo.TENANTID + "_" + scope.loginInfo.USERNAME, scope.loginInfo.TRUENAME)
                            .then((msgs) => {
                                msgs.forEach(item => {
                                    if (!item) return;
                                    sendMessageSuccess(item);
                                });
                            }, err => {
                                console.log(err);
                            });*/
                    }
                };
                scope.emotionsFn = {
                    /**
                     * [getEmotion description] 获取表情，并插入编辑器
                     * @param  {[type]} emotion [description]
                     * @return {[type]}         [description]
                     */
                    getEmotion(emotion) {
                        scope.status.ce.insertHtml(`<img class="emotion" src="${emotion.src}">`);
                    },
                    /**
                     * [emotionsShow description] 显示表情列表的回到函数，此时编辑器应当聚焦
                     * @return {[type]} [description]
                     */
                    emotionsShow() {
                        scope.status.ce.editorFocus();
                    }
                };
            }
            /**
             * [getGroupInfo description] 获取群信息
             * @return {[type]} [description]
             */
            function getGroupInfo() {
                let deffer = $q.defer();
                imService.getGroupInfo(scope.sessionInfo.ToAccount).then(resp => {
                    deffer.resolve(resp);
                });
                return deffer.promise;
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                scope.loaders = imService.getGroupInfo(scope.sessionInfo.ToAccount).then(resp => {
                    scope.loaders = imService.getGroupHistory(scope.sessionInfo.ToAccount, 15, resp[0].NextMsgSeq - 1);
                    return scope.loaders;
                }).then(resp => {
                    scope.data.groupHistoryMsgs = angular.isArray(resp) ? resp : [];
                    scrollToBottom();
                    setAutoRead();
                });
                listenNewMessage();
            }
        }
    };
}]);